import { getCryptoConfig } from '@/api/login.js';
import { sm2, sm3, sm4 } from 'sm-crypto';

const { publicKey, privateKey } = sm2.generateKeyPairHex();
let algorithm = 'SM4';
let config = {
  key: '',
  iv: '',
  mode: '',
  padding: '',
  enabled: false,
};

/**
 * 字符串转十六进制
 * @param str
 */
const strToHex = str => {
  let hexString = '';
  for (let i = 0; i < str?.length; i++) {
    let hex = str.charCodeAt(i).toString(16);
    hexString += hex.length === 1 ? '0' + hex : hex;
  }
  return hexString;
};

const getSign = () => {
  const timestamp = new Date().getTime();
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let nonce = '';
  const length = 32;
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * chars.length);
    nonce += chars.charAt(randomIndex);
  }
  const digestStr = sm3(
    [String(timestamp), nonce, publicKey].sort((a, b) => a.localeCompare(b)).join('')
  );
  const signature = sm2.doSignature(digestStr, privateKey, {
    der: true,
    hash: true,
    userId: '1234567812345678',
  });
  let pk = encryptDataBySM2(publicKey);
  return {
    timestamp,
    nonce,
    signature,
    publicKey: pk,
  };
};

// 获取加密配置
export const getCrypto = () => {
  getCryptoConfig(getSign()).then(res => {
    algorithm = res.algorithm;
    if (algorithm === 'sm2') {
      config = decryptDataBySM2(res.config);
      if (config) {
        config = JSON.parse(config || {});
      }
    }
  });
};

// 加密
export const encrypt = word => {
  if (config.enabled) {
    if (config.algorithm === 'SM4') {
      return encryptBySM4(word, config);
    } else {
      throw new Error('不支持此加密算法：' + config.algorithm);
    }
  } else {
    return word;
  }
};

// 解密
export const decrypt = word => {
  if (config.enabled) {
    if (config.algorithm === 'SM4') {
      return decryptBySM4(word, config);
    } else {
      throw new Error('不支持此加密算法：' + config.algorithm);
    }
  } else {
    return word;
  }
};

const convertPadding = padding => {
  if (padding === 'NoPadding') {
    return 'none';
  } else if (padding === 'PKCS5Padding') {
    return 'pkcs#5';
  } else {
    return 'none';
  }
};

export const encryptBySM4 = (word, config) => {
  if (!word) return '';
  return sm4.encrypt(word, strToHex(config?.key), {
    padding: convertPadding(config?.padding),
    mode: config?.mode?.toLowerCase(),
    iv: strToHex(config?.iv),
  });
};

export const decryptBySM4 = (word, config) => {
  if (!word) return '';
  return sm4.decrypt(word, strToHex(config?.key), {
    padding: convertPadding(config?.padding),
    mode: config?.mode?.toLowerCase(),
    iv: strToHex(config?.iv),
  });
};

/**
 * 解密数据
 * @param {Object} dataHex 加密的密文数据
 */
export function decryptDataBySM2(encryptData) {
  if (encryptData && typeof encryptData === 'string' && encryptData.constructor === String) {
    const decryptData = sm2.doDecrypt(encryptData.substring(2), privateKey, 1);
    return decryptData;
  }
}

export function encryptDataBySM2(str) {
  const publicKey = process.env.VUE_APP_PUBK;
  if (str && typeof str === 'string' && str.constructor === String) {
    const encryptData = sm2.doEncrypt(str, publicKey, 1);
    return '04'.concat(encryptData);
  }
}
